export default __webpack_public_path__ + "static/media/warning--lane-closed-in-dual-lanes-left--g2.3509b0fc.png";